import React from "react";
import PropTypes from "prop-types";
import { HighlightProvider as SharedHighlightProvider } from "@learningblocks/shared-components";
import { useHighlight } from "@learningblocks/shared/glossary";
import cName from "./style.module.scss";
import { RichText } from "@learningblocks/shared-components/lib/RichText";

/**
 * Question
 *    -Component accepts the HTML question text and render it to HTML
 */

export function Question(props) {
  const { onPlainTextClick } =
    React.useContext(SharedHighlightProvider.Context) || useHighlight();

  const onClickHighlight = (contentId, event) => {
    onPlainTextClick(contentId, event);
  };

  const renderQuestionCaption = () => {
    if (props.addMultiSelectText) {
      return (
        <div className={cName.questionCaption}>(Select all that apply)</div>
      );
    }
    return null;
  };

  const isPlainString = typeof props.text === "string";
  if (isPlainString) {
    return (
      <p>
        <RichText
          className={`${cName.question} ${props.className}`}
          onClickHighlight={onClickHighlight}
          value={props.text}
        />
        {renderQuestionCaption()}
      </p>
    );
  }
  return (
    <>
      <RichText
        className={`${cName.question} ${props.className}`}
        onClickHighlight={onClickHighlight}
        {...props.text}
      />
      {renderQuestionCaption()}
    </>
  );
}

Question.propTypes = {
  /**
   * Text to be displayed as question
   * Expects a string or object
   */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  /**
   * ClassName to set on the tag
   */
  className: PropTypes.string,
  /**
   * Whether to add "Select all that apply" caption for multi-select questions
   */
  addMultiSelectText: PropTypes.bool,
};

Question.defaultProps = {
  text: "",
  className: "",
  addMultiSelectText: false,
};
